import React from 'react';
import { object, bool } from 'prop-types';
import { Route } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';

const RouteFromPath = route => (
  route.private ?
    <PrivateRoute
      {...route}
      authenticated={route.authenticated}
    /> :
    <Route {...route} />
);

RouteFromPath.propTypes = {
  route: object,
  authenticated: bool.isRequired
};

export default RouteFromPath;



// WEBPACK FOOTER //
// ./src/components/routes/RouteFromPath.js